import React from 'react';
import { BreadcrumbManager } from '@atlassian/jira-breadcrumbs/src/breadcrumb-manager/index.tsx';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import ProjectBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';
import type { ProjectSettingsBreadcrumbProps } from './types';

const ProjectSettingsBreadcrumb = ({
	baseUrl,
	projectKey,
	projectName,
}: ProjectSettingsBreadcrumbProps) => {
	const { formatMessage } = useIntl();

	return (
		<BreadcrumbManager>
			<BreadcrumbRenderer />
			<ProjectBreadcrumb baseUrl={baseUrl} projectKey={projectKey} projectName={projectName}>
				<Breadcrumb
					breadcrumb={{
						href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/reports`,
						text: formatMessage(messages.reportsBreadcrumbTitle),
						type: 'projectSettings',
					}}
				/>
			</ProjectBreadcrumb>
		</BreadcrumbManager>
	);
};

export default ProjectSettingsBreadcrumb;
